<template>
  <div class="list" name="info">
    <el-card class="searchCard" shadow="never">
      <el-col>
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="创建时间">
            <date-range-picker
              :value="comeTime"
              @getChange="dateChange"
              disabledBeforeDate='-1'>
            </date-range-picker>
          </el-form-item>
          <el-form-item label="乐刷商户号">
            <el-input class="search-input" v-model="searchForm.merchantId" clearable></el-input>
          </el-form-item>
          <el-form-item label="支付宝商户号">
            <el-input class="search-input" v-model="searchForm.subMerchantId" clearable></el-input>
          </el-form-item>
          <el-form-item label="店铺编号">
            <el-input class="search-input" v-model="searchForm.storeId" clearable></el-input>
          </el-form-item>
          <el-form-item label="店铺状态">
            <el-select class="search-input" v-model="searchForm.status" clearable>
              <el-option value="" label="全部"></el-option>
              <el-option v-for="item in statusList" :value="item.value" :key="item.value" :label="item.text"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttonSearch"
              :loading="searchLoading"
              label="查询"></auth-button>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="add"
              @click.native="handleAdd"
              label="创建店铺"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="searchLoading"
        :data="list"
        :header-cell-style="{background:'#FAFAFA'}"
      >
        <el-table-column
          prop="merchantId"
          label="乐刷商户号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="subMerchantId"
          label="支付宝商户号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="merchantPId"
          label="支付宝PID"
          align="center">
        </el-table-column>
        <el-table-column
          prop="storeId"
          label="店铺编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="shopName"
          label="店铺名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="shopId"
          label="店铺ID"
          align="center">
        </el-table-column>
        <el-table-column
          prop="status"
          label="店铺状态"
          align="center">
          <template slot-scope="scope">
            <span>{{ renderStatus(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTimeStr"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center">
          <template slot-scope="scope">
            <auth-button
              opt="update"
              type="text"
              @click.native="updateStatus(scope.row)"
              label="更新店铺状态"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        class="pagination"
        v-if="paginations.total>0"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <el-dialog
      title="创建店铺"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @close="$refs['addForm'].resetFields()">
      <el-form :model="addForm" label-width="110px" label-position="left" ref="addForm" :rules="formRules">
          <el-form-item label="乐刷商户号" prop="merchantId">
            <el-input class="form-input" v-model="addForm.merchantId" @blur="queryShopLevel"></el-input>
          </el-form-item>
          <el-form-item label="支付宝商户号" prop="subMerchantId">
            <el-input class="form-input" v-model="addForm.subMerchantId" disabled></el-input>
          </el-form-item>
          <el-form-item label="支付宝商户等级" prop="shopLevel">
            <div><span class="merchantLevel">{{addForm.shopLevel}}</span>
              <a v-if="addForm.shopLevel !== 'M4'" target="_blank" href="https://www.yuque.com/docs/share/498449c5-18f6-4ce2-8771-4ec34aff37b4?#"  style="text-decoration:underline;margin-left: 10px;">如何升级M4?</a>
            </div>
          </el-form-item>
          <el-form-item label="支付宝PID" prop="merchantPId">
            <el-input class="form-input" v-model="addForm.merchantPId"></el-input>
            <div>
              <img class="PIDQrcCode" src="../../../../static/images/PID.png">
              <span>商户支付宝扫描二维码，获取PID</span>
            </div>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit" style="align:center" :disabled="addForm.shopLevel !== 'M4'">创建店铺</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import { addRuyiShop, listRuyiShop, getReportInfo, updateShopStatus } from '@/api/machine'
export default {
  components: {
    dateRangePicker
  },
  data () {
    return {
      comeTime: [],
      searchForm: {
        createTimeEnd: '',
        createTimeStart: '',
        merchantId: '',
        subMerchantId: '',
        storeId: '',
        status: '',
        pageSize: 10
      },
      addForm: {
        merchantId: '',
        subMerchantId: '',
        shopLevel: '',
        merchantPId: ''
      },
      statusList: [{
        text: '创建成功',
        value: 1
      }, {
        text: '创建失败',
        value: 2
      }, {
        text: '已完结',
        value: 3
      }, {
        text: '待审核',
        value: 4
      }, {
        text: '审核拒绝',
        value: 5
      }],
      searchLoading: false,
      dialogVisible: false,
      isAdd: false,
      formRules: {
        merchantId: [{
          required: true,
          message: '请选择乐刷商户号'
        }],
        subMerchantId: [{
          required: true,
          message: '请选择支付宝商户号',
          trigger: 'blur'
        }],
        merchantPId: [{
          required: true,
          message: '请输入支付宝PID'
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      if (this.comeTime) {
        [this.searchForm.createTimeStart, this.searchForm.createTimeEnd] = this.comeTime
      }
      this.searchLoading = true
      var data = this.formatSearch(this.searchForm)
      data = qs.stringify(data)
      listRuyiShop(data).then((res) => {
        this.searchLoading = false
        if (parseInt(res.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: res.error_msg,
            type: 'error'
          })
        } else {
          this.paginations.total = res.totalCount
          this.list = res.list
        }
      })
    },
    dateChange (value) {
      this.comeTime = value
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      var totalCount = this.machinesNum
      this.searchForm.pageNo = page
      this.searchForm.Count = totalCount
      this.getList()
    },
    buttonSearch () {
      // 当点击查询时，显示第一页
      this.searchForm.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    handleAdd () {
      this.isAdd = true
      this.$refs.addForm && this.$refs.addForm.resetFields()
      this.dialogVisible = true
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        } else {
          data[s] = this.$jquery.trim(data[s])
        }
      }
      return data
    },
    // 点击搜索按钮事件
    onSearch () {
      this.searchLoading = true
      this.searchForm.pageNo = 1
      this.getList()
    },
    queryShopLevel (e) {
      const data = qs.stringify({ merchantId: e.target.value })
      getReportInfo(data).then((res) => {
        if (parseInt(res.error_code) === 0) {
          if (res.data) {
            if (typeof res.data === 'string') { res.data = JSON.parse(res.data) }
            this.addForm.subMerchantId = res.data.subMerchantId
            this.addForm.shopLevel = res.data.level
          } else {
            this.addForm.subMerchantId = ''
            this.addForm.shopLevel = ''
          }
        } else {
          this.addForm.subMerchantId = ''
          this.addForm.shopLevel = ''
          this.$message({
            showClose: true,
            message: res.error_msg,
            type: 'error'
          })
        }
        this.$forceUpdate()
      })
    },
    updateStatus (row) {
      const data = qs.stringify({
        orderId: row.orderId,
        merchantId: row.merchantId
      })
      updateShopStatus(data).then(res => {
        if (parseInt(res.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: res.error_msg,
            type: 'error'
          })
        } else {
          this.$message({
            showClose: true,
            message: '更新成功',
            type: 'success'
          })
          this.getList()
        }
      })
    },
    handleSubmit () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const data = qs.stringify(this.addForm)
          addRuyiShop(data).then((res) => {
            if (parseInt(res.error_code) !== 0) {
              this.$message({
                showClose: true,
                message: res.error_msg,
                type: 'error'
              })
            } else {
              this.$message({
                showClose: true,
                message: res.error_msg,
                type: 'success'
              })
              this.dialogVisible = false
              this.buttonSearch()
            }
          })
        }
      })
    },
    renderStatus (status) {
      const result = this.statusList.filter((item) => {
        return item.value === status
      })
      if (result.length > 0) {
        return result[0].text
      } else {
        return '未知'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .btm-action {
    margin-top: 20px;
    text-align: center;
  }
  /deep/ .el-dialog__footer {
    text-align: center;
  }
  .form-input {
    width: 70%;
  }
  /deep/ .el-dialog__body {
    margin-left: 12px;
    padding-bottom: 0;
  }
  .pagination {
    display: inline-block;
  }
  .merchantLevel {
    width: 40px;
    display: inline-block;
  }
  .PIDQrcCode {
    width: 100px;
    height: 100px;
    margin-top: 10px;
  }
</style>
